<template>
    <div class="Information">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>APSS Case</h4>
                        <p>
                            <span class="bold">Family Name: </span>
                            <StringEditor v-bind:old-value="RecordData.Name"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Family Name"
                                          property-name="Name"
                                          update-method="PostAdopt/CommunityFamilies"
                                          v-bind:required="true"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Case Number: </span>
                            <StringEditor v-bind:old-value="RecordData.CaseNumber"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Case Number"
                                          property-name="CaseNumber"
                                          update-method="PostAdopt/CommunityFamilies"
                                          v-bind:required="false"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Running Summary: </span>
                            <TextAreaEditor v-bind:old-value="RecordData.RunningSummary"
                                            v-bind:record-id="RecordData.Id"
                                            v-bind:edit-mode="EditMode"
                                            data-label="Running Summary"
                                            property-name="RunningSummary"
                                            update-method="PostAdopt/CommunityFamilies"
                                            v-bind:required="false"
                                            http-method="PATCH"
                                            :chart-id="RecordData.Id" />
                        </p>
                    </div>
                    <div class="record-section">
                        <h4>Important Dates</h4>
                        <p>
                            <span class="bold">Referral Date: </span>
                            <DateEditor v-bind:old-value="RecordData.ReferralDate"
                                        v-bind:record-id="RecordData.Id"
                                        v-bind:edit-mode="EditMode"
                                        data-label="Referral Date"
                                        property-name="ReferralDate"
                                        update-method="PostAdopt/CommunityFamilies"
                                        :global-update="true"
                                        v-bind:required="false"
                                        http-method="PATCH"
                                        :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Start Date: </span>
                            <DateEditor v-bind:old-value="RecordData.StartDate"
                                        v-bind:record-id="RecordData.Id"
                                        v-bind:edit-mode="EditMode"
                                        data-label="Start Date"
                                        property-name="StartDate"
                                        update-method="PostAdopt/CommunityFamilies"
                                        :global-update="true"
                                        v-bind:required="false"
                                        http-method="PATCH"
                                        :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Term Date: </span>
                            <DateEditor v-bind:old-value="RecordData.EndDate"
                                        v-bind:record-id="RecordData.Id"
                                        v-bind:edit-mode="EditMode"
                                        data-label="Term Date"
                                        property-name="EndDate"
                                        update-method="PostAdopt/CommunityFamilies"
                                        :global-update="true"
                                        v-bind:required="false"
                                        http-method="PATCH"
                                        :chart-id="RecordData.Id" />
                        </p>
                    </div>
                    <div class="record-section">
                        <h4>Intake Dates</h4>
                        <p>
                            <span class="bold">Initial Contact with CSW Date: </span>
                            <DateEditor v-bind:old-value="RecordData.InitialCSWContactDate"
                                        v-bind:record-id="RecordData.Id"
                                        v-bind:edit-mode="EditMode"
                                        data-label="Initial Contact with CSW Date"
                                        property-name="InitialCSWContactDate"
                                        update-method="PostAdopt/CommunityFamilies"
                                        :global-update="true"
                                        v-bind:required="false"
                                        http-method="PATCH"
                                        :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Initial Contact with Client Date: </span>
                            <DateEditor v-bind:old-value="RecordData.InitialClientContactDate"
                                        v-bind:record-id="RecordData.Id"
                                        v-bind:edit-mode="EditMode"
                                        data-label="Initial Contact with Client Date"
                                        property-name="InitialClientContactDate"
                                        update-method="PostAdopt/CommunityFamilies"
                                        :global-update="true"
                                        v-bind:required="false"
                                        http-method="PATCH"
                                        :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Intake Date: </span>
                            <DateEditor v-bind:old-value="RecordData.IntakeDate"
                                        v-bind:record-id="RecordData.Id"
                                        v-bind:edit-mode="EditMode"
                                        data-label="Intake Date"
                                        property-name="IntakeDate"
                                        update-method="PostAdopt/CommunityFamilies"
                                        :global-update="true"
                                        v-bind:required="false"
                                        http-method="PATCH"
                                        :chart-id="RecordData.Id" />
                        </p>
                    </div>
                </div>

                <div class="col col-md-4">
                    <div class="record-section">
                        <h4>Family</h4>
                        <div v-for="client in RecordData.Clients">
                            <p><span class="bold">{{ client.Client.Person.FullName }}</span><span> ({{ client.Client.ClientType }})</span><span> ({{ client.Client.Person.DOB }})</span></p>
                            <p style="margin-left:20px;"><span></span><span>{{ client.Client.Person.Language }}</span></p>
                            <p v-if="client.Client.Person.Email" style="margin-left:20px;"><a :href="'mailto:' + client.Client.Person.Email">{{client.Client.Person.Email}}</a></p>
                            <p v-for="(phoneNumber, phoneIndex) in client.Client.Person.PhoneNumbers" style="margin-left:20px;">
                                <span>{{ phoneNumber.PhoneNumber.PhoneType }}: </span><a :href="'tel:' + phoneNumber.PhoneNumber.PhoneNumberDigits">{{ phoneNumber.PhoneNumber.FormattedPhoneNumber }}</a> {{ phoneNumber.PhoneNumber.Description ? '(' + phoneNumber.PhoneNumber.Description + ')' : '' }}
                            </p>
                        </div>
                    </div>
                    <div class="record-section">
                        <p><span class="bold">CAFAS/PECFAS & PAPF Survey/Scoring: </span><span>  </span></p>
                    </div>
                </div>
                <div class="col col-md-4">
                    <div class="record-section">
                        <h4>Address</h4>
                        <p>
                            <AddressEditor v-bind:old-value="RecordData.PhysicalAddress"
                                           v-bind:record-id="RecordData.PhysicalAddress.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="Physical Address"
                                           update-method="Core/Address/Update"
                                           required="true" />
                        </p>
                        <p>
                            <span class="bold">Territory: </span>
                            <SelectEditor v-bind:old-value="RecordData.SubProgramTerritoryID"
                                          v-bind:old-value-text="RecordData.SubProgramTerritory.Name"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Territory"
                                          property-name="SubProgramTerritoryID"
                                          update-method="PostAdopt/CommunityFamilies"
                                          required="true"
                                          :options="SubProgramTerritoryOptions"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                    </div>

                </div>
            </div>
        </div>

        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" permission="" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import StringEditor from '../../../../Core/ItemEditors/StringEditor';
    import DateEditor from '../../../../Core/ItemEditors/DateEditor';
    import SelectEditor from '../../../../Core/ItemEditors/SelectEditor';
    import PersonEditor from '../../../../Core/ItemEditors/PersonEditor';
    import EditMode from '../../../../Core/ItemEditors/EditMode.vue';
    import AddressEditor from '../../../../Core/ItemEditors/AddressEditor.vue';
    import TextAreaEditor from '../../../../Core/ItemEditors/TextAreaEditor.vue';
    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                EditMode: false,
                sampleStartDate: '2023-01-01',
                sampleReferralDate: '2023-02-01',
                sampleEffectiveDate: '2023-03-01',
                sampleIntakeDate: '2023-04-01',
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
            updateSampleDate(field, value) {
                this[field] = value;
            }
        },
        components: {
            StringEditor,
            DateEditor,
            SelectEditor,
            PersonEditor,
            EditMode,
            AddressEditor,
            TextAreaEditor
        },
        mounted() {

        },
        computed: {
            SubProgramTerritoryOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramTerritoryOptions"]();
            }
        }
    }
</script>

<style scoped>
</style>